import { handleServiceError } from '../helpers/app';
import { Agent } from '../interfaces/Agent';
import apiRequest from './apiService';

const createAgent = async (data: Agent) => {
  try {
    const result = await apiRequest(
      'agent',
      'POST',
      '/agent/create_agent',
      data
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

const getAgent = async (id: string) => {
  try {
    const result = await apiRequest('agent', 'GET', `/agent/get_agent/${id}`);
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

const getAgents = async (agentIds: string[] = []) => {
  try {
    const result = await apiRequest(
      'agent',
      'GET',
      `/agent/get_agents/${agentIds.join(',')}`
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

const getCompanyAgents = async () => {
  try {
    const result = await apiRequest(
      'agent',
      'GET',
      '/agent/get_company_agents'
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

const updateAgent = async (id: string, data: any = {}) => {
  try {
    const result = await apiRequest(
      'agent',
      'PUT',
      `/agent/update_agent/${id}`,
      data
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

const deleteAgent = async (id: string) => {
  try {
    const result = await apiRequest(
      'agent',
      'DELETE',
      `/agent/delete_object/${id}`
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

const testAgent = async (data: { id: string; phone_number: string }) => {
  try {
    const result = await apiRequest(
      'agent',
      'POST',
      `/agent/test_agent/${data.id}`,
      data
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

export interface UploadEmployeeDirectoryResult {
  status: string;
  message: {
    agent_id: string;
    inserted: number;
    skipped_invalid: number;
    deleted_previous: number;
    failed?: number;
  };
}

const uploadEmployeeDirectory = async (
  agentId: string,
  fileContent: string
): Promise<UploadEmployeeDirectoryResult> => {
  const result = await apiRequest(
    'agent',
    'POST',
    `/agent/upload_employee_directory/${agentId}`,
    { file_content: fileContent },
    null,
    120000
  );
  return result;
};

export interface EmployeeDirectoryRow {
  first_name: string;
  last_name: string;
  phone_number: string;
  extension: string;
  backup_phone_number: string;
  department_name: string;
  department_phone_number: string;
  department_email: string;
  department_description: string;
  job_title: string;
  email: string;
  backup_email: string;
  company: string;
  location: string;
}

export interface ValidateEmployeeDirectoryResult {
  status: string;
  message: {
    agent_id: string;
    total_rows: number;
    valid_rows: number;
    skipped_invalid: number;
    skipped_duplicates: number;
    rows: EmployeeDirectoryRow[];
  };
}

const validateEmployeeDirectory = async (
  agentId: string,
  fileContent: string
): Promise<ValidateEmployeeDirectoryResult> => {
  const result = await apiRequest(
    'agent',
    'POST',
    `/agent/validate_employee_directory/${agentId}`,
    { file_content: fileContent },
    null,
    120000
  );
  return result;
};

export {
  createAgent,
  getAgent,
  getAgents,
  getCompanyAgents,
  updateAgent,
  deleteAgent,
  testAgent,
  uploadEmployeeDirectory,
  validateEmployeeDirectory,
};
